class PasswordModal extends DetailsModal {
  constructor() {
    super();

    // if (this.querySelector('.password-header-container input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);
